// extracted by mini-css-extract-plugin
export var navLinkWrapperStyle = "section_alternating_layout_body-module--navLinkWrapperStyle--DXvpY";